import Dialog from '@mui/material/Dialog';
import {
  amountText,
  closeBtn,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  secondaryText,
  tableCell,
  tableHeaderCell,
  tableRowStyle,
} from './DetailsModal.sx';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  Button,
  DialogActions,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import useDetailsModal from 'app/pages/SalaryPage/PaymentsHistory/DetailsModal/useDetailsModal';
import {
  black1,
  green,
  grey,
  grey10,
  grey13Opacity60,
  orangeDefault,
  redDefault,
  white,
  yellow,
} from 'app/components/ThemeProvider/colors';
import { pagination } from 'app/pages/SalaryPage/SalaryPage.sx';
import {
  useGetSalaryHistoryDetail,
  useGetSalaryHistoryFile,
  useUpdateSalaryHistoryRepayment,
} from 'app/utils/services/salaryServices';
import { SalaryStatus } from 'app/utils/services/types/salary.type';
import { serverUrl } from 'app/constants/enviroments';

interface Props {
  open: any;
  close: any;
  dataDetails?: any;
  trn_id?: string;
  refetch: () => void;
}
const StatusIndicator = ({ status }: { status: SalaryStatus }) => {
  const statusConfig = {
    closed: { color: green, label: 'İcra edilib' },
    inprocess: { color: yellow, label: 'İcradadır' },
    declined: { color: redDefault, label: 'İcra edilməyib' },
  };

  const { color, label } = statusConfig?.[status] || {};

  return (
    <>
      {color && label && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: color }}></Box>
          <Typography>{label}</Typography>
        </Box>
      )}
    </>
  );
};
const DetailsModal = (props: Props) => {
  const { open, close, trn_id, refetch } = props;
  const { data } = useGetSalaryHistoryDetail(trn_id, open);
  const getSalaryFile = useGetSalaryHistoryFile();
  const updateSalaryHistoryRepayment = useUpdateSalaryHistoryRepayment();

  const handleDownload = () => {
    getSalaryFile.mutate(trn_id, {
      onSuccess: (fileDownloadData: any) => {
        const url = `${serverUrl}${fileDownloadData?.print_forms[0]?.fileLink}`;
        const link = document.createElement('a');
        link.href = url;
        link.download = fileDownloadData?.print_forms[0]?.fileName;
        window?.document.body.appendChild(link);
        link.click();

        window?.document.body.removeChild(link);
      },
    });
  };

  const { smallScreen, tableHeader } = useDetailsModal();

  const handleSingleRepayment = (id: string) => {
    updateSalaryHistoryRepayment.mutate(
      {
        form_id: 'salary_details',
        trn_id,
        id,
      },
      {
        onSuccess: () => {
          refetch();
          close(false);
        },
      }
    );
  };

  const handleRepayment = () => {
    updateSalaryHistoryRepayment.mutate(
      {
        form_id: 'salary_details',
        trn_id,
      },
      {
        onSuccess: () => {
          refetch();
          close(false);
        },
      }
    );
  };

  return (
    <>
      <Dialog fullScreen={true} open={open} onClose={() => close(false)}>
        <DialogTitle sx={dialogTitle}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>Ödənişin detalları</Typography>
            <Typography sx={secondaryText}>{data?.details?.date}</Typography>
          </Box>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={dialogContent}>
          <Box sx={dialogContentBoxes} id={'requisiteData'}>
            <Grid
              sx={{ display: 'flex', width: '668px', flexWrap: 'wrap', padding: '0px 42px' }}
              container
              rowSpacing="36px"
              columnSpacing={{ xs: smallScreen ? 0 : 10, sm: 0, md: 0 }}
            >
              <Grid item xs={6}>
                <Box>
                  <Typography sx={{ color: grey13Opacity60 }}>Məxaric hesabı</Typography>
                  <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{data?.details?.dc_acc_no}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography sx={{ color: grey13Opacity60 }}>Komissiyanın məxaric hesabı</Typography>
                  <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{data?.details?.com_acc_no}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ gap: '8px' }}>
                  <Typography sx={{ color: grey13Opacity60 }}>Məbləğ</Typography>
                  <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{data?.details?.amount}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography sx={{ color: grey13Opacity60 }}>Komisiya</Typography>
                  <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{data?.details?.commission_amount}</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography sx={{ color: grey13Opacity60 }}>Təyinat</Typography>
                  <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{data?.details?.description}</Typography>
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                marginTop: '28px',
                gap: '16px',
                flexDirection: 'column',
                minWidth: '380px',
                padding: '0px 42px',
              }}
            >
              <Typography sx={{ color: grey13Opacity60 }}>Ödənişin statusu</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '36px' }}>
                <Box sx={{ gap: '4px' }}>
                  <Typography sx={secondaryText}>İcra edilən</Typography>
                  <Typography sx={amountText}>{data?.details?.amount_closed}</Typography>
                </Box>
                <Box sx={{ gap: '4px' }}>
                  <Typography sx={secondaryText}>İcradadır</Typography>
                  <Typography sx={{ ...amountText, color: orangeDefault }}>
                    {data?.details?.amount_inprocess}
                  </Typography>
                </Box>
                <Box sx={{ gap: '4px' }}>
                  <Typography sx={secondaryText}>İcra edilməyən</Typography>
                  <Typography sx={{ ...amountText, color: redDefault }}>{data?.details?.amount_declined}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                minWidth: '600px',
                padding: '0px 42px',
              }}
            >
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>İşçilərin siyahısı</Typography>
                {data?.buttons?.print_form && (
                  <Button onClick={handleDownload}>
                    <img src={data?.buttons?.print_form?.icon} alt="print" width={22} height={22} />
                    {data?.buttons?.print_form?.text}
                  </Button>
                )}
              </Box>
              {data?.actions?.repayment?.enabled && (
                <Button onClick={handleRepayment} color={'success'}>
                  {data?.actions?.repayment?.text}
                </Button>
              )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '36px' }}>
              <TableContainer sx={{ marginTop: '33px', width: '120%' }}>
                <Table>
                  <TableHead>
                    <TableRow sx={tableRowStyle}>
                      {tableHeader.map((item, index) => (
                        <TableCell key={item.id} sx={{ ...tableHeaderCell }}>
                          <Typography sx={{ fontSize: '15px', color: grey, lineHeight: '1' }}>{item.name}</Typography>
                        </TableCell>
                      ))}
                      <TableCell
                        sx={{ ...tableHeaderCell, width: '150px', fontSize: '15px', color: grey, lineHeight: '1' }}
                      >
                        Status
                      </TableCell>
                      <TableCell sx={{ ...tableHeaderCell, width: '90px' }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.workers_payments?.map((row, index: number) => (
                      <TableRow
                        key={row.id}
                        sx={
                          (+index + 1) % 2 === 0
                            ? { ...tableRowStyle, background: white }
                            : { ...tableRowStyle, background: grey10 }
                        }
                      >
                        <TableCell sx={{ ...tableCell, width: '380px' }}>
                          <Typography
                            sx={{ fontWeight: 600, fontSize: '17px', color: black1, lineHeight: '1', width: '380px' }}
                          >
                            {row.full_name}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ ...tableCell, width: '400px' }}>
                          <Typography sx={{ fontWeight: 600, fontSize: '17px', color: black1, lineHeight: '1' }}>
                            {row.iban}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ ...tableCell, width: '150px' }}>
                          <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>{row.amount} </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            p: '21px 0',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            width: '150px',
                            justifyContent: 'flex-start',
                          }}
                        >
                          <StatusIndicator status={row?.status} />
                        </TableCell>
                        <TableCell
                          sx={{
                            p: '21px 0',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            width: '90px',
                            justifyContent: 'flex-end',
                          }}
                        >
                          {!!row?.actions?.length && (
                            <Button size={'small'} color={'success'} onClick={() => handleSingleRepayment(row?.id)}>
                              Yenidən ödə
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            {data?.total_pages > 1 && (
              <Pagination
                sx={{ ...pagination, mt: '28px', ml: '32px' }}
                count={10}
                variant="outlined"
                shape="rounded"
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ pl: '40px', pb: '40px', pr: '40px', mt: '24px' }}>
          <Button onClick={() => close(false)} color={'tertiary'} sx={{ width: '100%' }}>
            Bağla
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DetailsModal;
